module.exports = __webpack_public_path__ + "static/media/check_box.0009c083.svg";